<template>
  <div v-html="resource"></div>
</template>

<script>
export default {
  props: {
    resource: String,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">


.payment-systems {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 20px;
  padding: 10px 0;
}

.payment-system {
  background-repeat: no-repeat;
  // Делает цветные иконки белыми, может пригодиться для ховера
  //filter: brightness(0) invert(1);
  transition: filter 300ms linear;
  
  &:hover {
    filter: unset;
  }

  &.payment-system_all {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    max-width: 120px;
    text-align: center;
    filter: none;
    transition: none;
    margin-inline-start: auto;

    &:hover {
      filter: none;
    }

    > * {
      color: var(--white);
    }
  }
}

.payment-system_psb {
  background-image: url('@/assets/payments/psb_white.svg');
  width: 110px;
  height: 34px;
}

.payment-system_alfa {
  background-image: url('@/assets/payments/alfa_white.svg');
  width: 76px;
  height: 34px;
}

.payment-system_tinkoff {
  background-image: url('@/assets/payments/tinkoff_white.svg');
  width: 90px;
  height: 21px;
  
  &:hover {
    background-image: url('@/assets/payments/tinkoff.svg');
  }
}

.payment-system_sber {
  background-image: url('@/assets/payments/sber_white.svg');
  width: 103px;
  height: 17px;
}

.payment-system_svyaznoy {
  background-image: url('@/assets/payments/svyaznoy_white.svg');
  width: 93px;
  height: 16px;
}

.payment-system_megafon {
  background-image: url('@/assets/payments/megafon_white.svg');
  width: 129px;
  height: 39px;

  &:hover {
    background-image: url('@/assets/payments/megafon.svg');
  }
}

.payment-system_mobile-app {
  background-image: url('@/assets/payments/mobile-app_white.svg');
  width: 29px;
  height: 28px;

  &:hover {
    background-image: url('@/assets/payments/mobile-app.svg');
  }
}

.payment-system_ukrsib {
  background-image: url('@/assets/payments/ukrsib_white.svg');
  width: 158px;
  height: 33px;
  
  &:hover {
    background-image: url('@/assets/payments/ukrsib.svg');
  }
}

.payment-system_crediteurope {
  background-image: url('@/assets/payments/crediteurope_white.svg');
  width: 249px;
  height: 33px;
  
  &:hover {
    background-image: url('@/assets/payments/crediteurope.svg');
  }
}

.payment-system_private {
  background-image: url('@/assets/payments/private_white.svg');
  width: 157px;
  height: 27px;

  &:hover {
    background-image: url('@/assets/payments/private.svg');
  }
}

.payment-system_evroset {
  background-image: url('@/assets/payments/evroset_white.svg');
  width: 100px;
  height: 27px;
}

.payment-system_mastercard {
  background-image: url('@/assets/payments/mastercard_white.svg');
  width: 30px;
  height: 23px;
}

.payment-system_mir {
  background-image: url('@/assets/payments/mir_white.svg');
  width: 68px;
  height: 34px;
}

.payment-system_rupost {
  background-image: url('@/assets/payments/rupost_white.svg');
  width: 55px;
  height: 27px;
}

.payment-system_visa {
  background-image: url('@/assets/payments/visa_white.svg');
  width: 58px;
  height: 34px;
}

.payment-system_beeline {
  background-image: url('@/assets/payments/beeline_white.svg');
  width: 100px;
  height: 34px;

  //&:hover {
  //  background-image: url('@/assets/payments/beeline.svg');
  //}
}

.payment-system_kzi-bank {
  background-image: url('@/assets/payments/kzi-bank_white.svg');
  width: 115px;
  height: 32px;
}

.payment-system_halyk {
  background-image: url('@/assets/payments/halyk_white.svg');
  width: 92px;
  height: 32px;
}

.payment-system_forte {
  background-image: url('@/assets/payments/forte_white.svg');
  width: 108px;
  height: 32px;
}

.payment-system_kaspi {
  background-image: url('@/assets/payments/kaspi_white.svg');
  width: 137px;
  height: 32px;
}

.payment-system_centercredit {
  background-image: url('@/assets/payments/centercredit_white.svg');
  width: 120px;
  height: 32px;
}

.payment-system_demir-bank {
  background-image: url('@/assets/payments/demir-bank_white.svg');
  width: 122px;
  height: 32px;
}
</style>

